<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="equipmentgrps_new" ttGoto="equipmentgrp" [ttGotoParms]="{ equipmentgrp_id: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListEquipmentGroups"></tt-list>
</tt-page>
